import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from '../models/api.models';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private keycloak: KeycloakService) {}

  getHaendlerId(): number {
    const token = this.keycloak.getKeycloakInstance().tokenParsed as any;
    return token?.profile?.haendlerId ?? token?.haendlerId;
  }

  getHaendlerBezeichnung(): string {
    const token = this.keycloak.getKeycloakInstance().tokenParsed as any;
    return token?.profile?.haendlerBezeichnung ?? token?.haendlerBezeichnung ?? '';
  }

  getUserId(): string {
    const token = this.keycloak.getKeycloakInstance().tokenParsed as any;
    return token?.sub ?? '';
  }

  /**
   * Erneuert das Token, wenn es in weniger als 30s abläuft, und gibt es zurück.
   * Leerer String bedeutet: keine brauchbare Sitzung.
   */
  async getToken(): Promise<string> {
    const kc = this.keycloak.getKeycloakInstance();
    try {
      await kc.updateToken(30);
    } catch {
      return '';
    }
    return kc.token ?? '';
  }

  /** Erzwingt einen Refresh (-1, denn 0 würde intern zu 5 werden). */
  async refreshToken(): Promise<string> {
    const kc = this.keycloak.getKeycloakInstance();
    try {
      await kc.updateToken(-1);
    } catch {
      return '';
    }
    return kc.token ?? '';
  }

  getUserName(): string {
    const token = this.keycloak.getKeycloakInstance().tokenParsed as any;
    return token?.name ?? token?.preferred_username ?? '';
  }

  logout(): void {
    this.keycloak.logout();
  }

  isLoggedIn(): boolean {
    return this.keycloak.getKeycloakInstance().authenticated ?? false;
  }

  isImpersonated(): boolean {
    const token = this.keycloak.getKeycloakInstance().tokenParsed as any;
    return !!token?.impersonator?.id;
  }

  hasRole(role: string): boolean {
    return this.keycloak.isUserInRole(role);
  }
}
